import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";

import Title from '../product/add_product/title';
import View from './view';

export default class Stocks extends React.Component {

  render() {
    let bills = (
      <Link to="/billing">
        <Button style={{color: 'white'}}>Billing</Button>
      </Link>
    );
    let purchase = (
      <Link to="/purchases">
        <Button style={{color: 'white'}}>Purchase Details</Button>
      </Link>
    );
    return (
      <div>
        <Title shopDetails={this.props.data} shopId={this.props.data.id} title={`${this.props.data.shop_name} ${this.props.logistics ? " - Add / Edit Product" : " - Add / Edit Stock" }`} menu={true} button1={bills} button2={purchase}/>
        <View logistics={this.props.logistics} data={this.props.data}/>
      </div>
    );
  }

}
